var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventoryManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "inventory-management",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.067,
    height: 17.705,
    viewBox: "0 0 19.067 17.705",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M21.375,27H24.1v2.724H21.375Z",
    transform: "translate(-9.799 -12.019)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M29.25,27h2.724v2.724H29.25Z",
    transform: "translate(-12.907 -12.019)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M21.375,19.125H24.1v2.724H21.375Z",
    transform: "translate(-9.799 -8.911)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M29.25,19.125h2.724v2.724H29.25Z",
    transform: "translate(-12.907 -8.911)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M12.464,17.231H3.612V7.7H19.955v3.4h1.362V7.7a1.363,1.363,0,0,0-1.362-1.362H15.869V3.612A1.363,1.363,0,0,0,14.507,2.25H9.059A1.363,1.363,0,0,0,7.7,3.612V6.336H3.612A1.363,1.363,0,0,0,2.25,7.7v9.533a1.363,1.363,0,0,0,1.362,1.362h8.852ZM9.059,3.612h5.448V6.336H9.059Z",
    transform: "translate(-2.25 -2.25)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryManagementIcon);
export default __webpack_public_path__ + "static/media/inventory-management-icon.440540a38a755678fcfdb9ced36a0253.svg";
export { ForwardRef as ReactComponent };